/**
 * Generates a unique, generic tracking number
 * Format: TRK-YYYYMMDD-XXXXX (where XXXXX is a random alphanumeric string)
 * 
 * @returns {string} A unique tracking number
 */
const generateTrackingNumber = () => {
  // Get current date in YYYYMMDD format
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const dateString = `${year}${month}${day}`;
  
  // Generate a random 5-character alphanumeric string
  const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // Removed potentially confusing chars like 0, O, 1, I
  let randomPart = '';
  
  for (let i = 0; i < 5; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomPart += characters.charAt(randomIndex);
  }
  
  // Add milliseconds for true uniqueness when generated in quick succession
  const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
  
  // Combine parts to create the tracking number
  return `TRK-${dateString}-${randomPart}${milliseconds}`;
};

export { generateTrackingNumber };
